// frontend/src/pages/ClientGroupPage.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getClientGroup, getClientsInGroup } from '../api';
import useClientRollup from '../hooks/useClientRollup';
import { tileDrilldown } from '../utils/rollup';
import {
  BreakdownByClientTable, DetailModal, GroupDistributionDonut, IncompleteDataBanner,
  MetricTiles, SummaryByYearTable, TimeByCodePie, TimeByEmployeePie,
} from '../components/rollup';

/** The group view reached from the Clients page's By-group mode. */
export default function ClientGroupPage() {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [group, setGroup] = useState(null);
  const [memberIds, setMemberIds] = useState([]);
  const [groupMetric, setGroupMetric] = useState('time');
  const [detailModal, setDetailModal] = useState(null);

  useEffect(() => {
    getClientGroup(groupId).then(setGroup).catch(() => setGroup(null));
    getClientsInGroup(groupId)
      .then((members) => setMemberIds(members.map((m) => m.id)))
      .catch(() => setMemberIds([]));
  }, [groupId]);

  const ids = useMemo(() => memberIds, [memberIds]);
  const rollup = useClientRollup(ids);

  if (!group) return <div style={{ padding: 24 }}>Loading…</div>;

  return (
    <div style={{ padding: 24 }}>
      <Link to="/clients" style={{ color: '#6b7280', textDecoration: 'none' }}>← Clients</Link>
      <h1 style={{ margin: '8px 0 4px' }}>{group.name}</h1>
      <div style={{ color: '#6b7280', marginBottom: 24 }}>
        {memberIds.length} {memberIds.length === 1 ? 'client' : 'clients'}
      </div>

      {rollup.partial && (
        <IncompleteDataBanner
          failedClientIds={rollup.failedClientIds}
          failedFetches={rollup.failedFetches}
        />
      )}

      <MetricTiles
        metrics={rollup.metrics}
        onTileClick={(tile) => setDetailModal(tileDrilldown(tile, rollup))}
      />
      <SummaryByYearTable rows={rollup.yearRows} onCellClick={setDetailModal} />
      <TimeByEmployeePie data={rollup.employeeData} />
      <TimeByCodePie data={rollup.codeData} />
      <GroupDistributionDonut
        data={rollup.clientRows}
        metric={groupMetric}
        onMetricChange={setGroupMetric}
      />
      <BreakdownByClientTable
        rows={rollup.clientRows}
        onClientClick={(clientId) => navigate(`/clients/${clientId}`)}
        onCellClick={setDetailModal}
        timeEntries={rollup.timeEntries}
        invoices={rollup.invoices}
        writeOffs={rollup.writeOffs}
      />

      {detailModal && (
        <DetailModal modal={detailModal} onClose={() => setDetailModal(null)} navigate={navigate} />
      )}
    </div>
  );
}
